// 模組03 機房管理 — mock 種子資料
//
// v2（Figma `2128:24125`）把機房從「四個欄位的一張表」變成有層次的東西：
//   機房 → 樓層 → 區域 →（機櫃 → 硬體／軟體）
// 樓層與區域是巢狀的可增可刪清單，不是兩個文字欄位 —— 列表的「樓層」「區域」
// 兩欄就是從這裡推導出來的。
//
// 欄位對齊新增/編輯畫面（`2128:24259` / `2128:24490`）：
//   基本資訊：name(中文名)・nameEn(英文名)・address・managerId/manager
//   樓層資訊：floors[] → areas[]
//   異動歷程：changeLog[]（編輯頁的第三張卡，唯讀）
export const rooms = [
  {
    id: 1,
    name: "台北內湖機房",
    nameEn: "TPE-NH DC",
    code: "TPE-NH",
    city: "台北市",
    address: "台北市內湖區瑞光路 358 號",
    managerId: 1,
    manager: "林承翰",
    floors: [
      { id: 1, name: "一樓", areas: [{ id: 11, name: "A區" }, { id: 12, name: "網通區" }] },
      { id: 2, name: "二樓", areas: [{ id: 21, name: "A區" }, { id: 22, name: "B區" }] },
    ],
    cabinetCount: 12,
    status: "啟用中",
    approvalStatus: "approved",
    // 編輯頁的異動歷程(設計稿 `2128:24507` 的四筆範例):誰、什麼時候、做了什麼、哪張單
    changeLog: [
      {
        at: "2026/06/05 16:03", by: "陳雅婷（EMP-0106）", action: "新增",
        detail: "新增機房「台北內湖機房（TPE-NH DC）」",
        docNo: "RQ-20260605-012", result: "已核准結案",
      },
      {
        at: "2026/06/18 09:41", by: "林承翰（EMP-0031）", action: "異動",
        detail: "異動機房「台北內湖機房（TPE-NH DC）」：管理者 由「王小明（A102345）」改為「周思吟（EMP-0210）」",
        docNo: "RQ-20260618-031", result: "已核准結案",
      },
      {
        at: "2026/07/02 14:20", by: "陳雅婷（EMP-0106）", action: "異動",
        detail: "異動機房「台北內湖機房（TPE-NH DC）」：機房區域 由「A區」改為「網通區」",
        docNo: "RQ-20260702-054", result: "審核中（第 2 關）",
      },
      {
        at: "2026/07/09 11:05", by: "林承翰（EMP-0031）", action: "刪除",
        detail: "刪除機房「新北備援機房（NTPC-BK DC）」",
        docNo: "RQ-20260709-067", result: "已退回（周思吟（EMP-0210），原因：仍有機櫃未解除）",
      },
    ],
  },
  {
    // 沒有任何機櫃 —— 刪除阻擋的「可以刪」那一邊要有樣本
    id: 2,
    name: "新北新莊機房",
    nameEn: "NTPC-XZ DC",
    code: "NTP-XZ",
    city: "新北市",
    address: "新北市新莊區中正路 200 號",
    managerId: 2,
    manager: "張家豪",
    floors: [{ id: 3, name: "一樓", areas: [{ id: 31, name: "A區" }] }],
    cabinetCount: 0,
    status: "啟用中",
    approvalStatus: "approved",
    changeLog: [],
  },
  {
    // 審核中 —— 列表要顯示「審核中｜單號」+ 黃底列,且表單整片鎖住
    id: 3,
    name: "桃園青埔機房",
    nameEn: "TYN-QP DC",
    code: "TYN-QP",
    city: "桃園市",
    address: "桃園市中壢區青埔路 66 號",
    managerId: 1,
    manager: "林承翰",
    floors: [{ id: 4, name: "一樓", areas: [{ id: 41, name: "A區" }] }],
    cabinetCount: 0,
    status: "啟用中",
    docNo: "RQ-20260609-003",
    approvalStatus: "pending",
    changeLog: [],
  },
  // 2026-10-20 SIT 樣本（DcRoom/GetById/3 原樣，個資已換假）
  // 連同 GetFloors/3（1F,id 5）與 GetAreas/5（A區,id 27）一起抄；SIT 這筆沒有英文名／地址／管理者
  // （null、manager_customer_id 0），投影照吐 null。mock id 3 已被桃園青埔用掉 → 這筆 mock id 4。
  // 本筆沒有個資欄位(管理者為 0／null),不需換假。
  {
    id: 4,
    name: "分行據點機房",
    nameEn: null,
    address: null,
    managerId: 0,
    manager: null,
    floors: [
      { id: 5, name: "1F", displayOrder: 0, areas: [{ id: 27, name: "A區", displayOrder: 0 }] },
    ],
    status: "啟用中",
    approvalStatus: "approved",
    createdOn: "2026-09-29T10:16:43.735485+08:00",
    updatedOn: "2026-09-29T10:16:43.735485+08:00",
    changeLog: [],
  },
];
